import { BaseComponent } from '@components/base.component';
import { Component, Input, OnInit } from '@angular/core';
import { AmericanFootballMapFce } from '@interfaces/match-data.interface';
import { ClientService } from '@services/client.service';
import { SourceId } from '@interfaces/source.interface';
import { toPairs } from 'lodash-es';
import SPORT_CONFIG from '@config/sport.config';
import { MATCH_ACTION_ANIMATION } from '@shared/animations/match-actions.animation';
import { trigger } from '@angular/animations';


@Component({
    selector: 'app-timeline-american-football',
    templateUrl: './american-football-timeline.component.html',
    animations: [trigger('newLine', MATCH_ACTION_ANIMATION)],
})
export class AmericanFootballTimelineComponent extends BaseComponent implements OnInit {
    @Input() data: AmericanFootballMapFce;
    @Input() sportName: string;
    @Input() sportId: number;

    public isUnknown = false;

    constructor(private client: ClientService) {
        super();
    }


    ngOnInit(): void {
        // console.log(`${this.sportName} data`, _.toPairs(this.data));

        this.isUnknown = Object.values(this.data)[0]!
            .some((value: Record<string, any>) => value.source_id === SourceId.BETSAPI);
    }

    get actions(): [string, Record<string, any>[]][] {
        return toPairs(this.data);
    }

    get color(): string {
        return this.client.has('colors', 'icons') || 'black';
    }

    isTypeUnknown(type: string): boolean {
        return this.isUnknown &&
            (
                type === SPORT_CONFIG.timeline.eventTypes.pass ||
                type === SPORT_CONFIG.timeline.eventTypes.extra_point ||
                type === SPORT_CONFIG.timeline.eventTypes.field_goal ||
                type === SPORT_CONFIG.timeline.eventTypes.rush ||
                type === SPORT_CONFIG.timeline.eventTypes.kickoff ||
                type === SPORT_CONFIG.timeline.eventTypes.punt ||
                type === SPORT_CONFIG.timeline.eventTypes.conversion ||
                type === SPORT_CONFIG.timeline.eventTypes.faircatch_kick ||
                type === SPORT_CONFIG.timeline.eventTypes.free_kick
            );
    }

    isTypeText(_type: string): boolean {
        return false;
    }
}
